/*
 * @Author: shannyHuang
 * @Date: 2022-08-11 14:08:26
 * @LastEditors: manuelzhao manuelzhao@tencent.com
 * @LastEditTime: 2022-11-14 23:52:34
 * @FilePath: /wemeet-web-activity/src/utils/browser/app-context.ts
 */
import { createContext } from 'react';
import type { HostDetailData } from '@model/host-account';
import { UserData } from '@utils/login-util';
import { Status } from '@model/show-activity-room';
import type { OrgList } from '@quickService/DashboardOrgGetUserHostOrgList';
import { ResourceDetailData } from '@hooks/useCommercialize';
const defaultHostDetail: Partial<HostDetailData> = {};
const defaultUserData: Partial<UserData> = {};
const defaultStatus: Partial<Status> = {};
const defaultHostList: Partial<OrgList> = [];
const defaultUpdateHostDetail = () => Promise.resolve();
// 商业化权限数据、请求状态、更新方法
const defaultVipResourceDetail: Partial<ResourceDetailData> = {
  vipResource: undefined,
  error: '',
  isValidating: false,
  updateVipResource: () => {},
};
const updateRegisterHostData = () => {};
const registerHostData: Partial<HostDetailData> = {};
const defaultValue: {
  isMobile?: boolean;
  isMeetingApp?: boolean;
  hostDetail: typeof defaultHostDetail;
  userData: typeof defaultUserData;
  isHost?: boolean;
  statusInfo?: typeof defaultStatus;
  isMobileUi?: boolean;
  registerHostData?: typeof registerHostData;
  userHostList?: typeof defaultHostList;
  vipResourceDetail?: typeof defaultVipResourceDetail;
  updateVipResource?: (hostId?: string) => void;
  updateAppCtxHostDetail: (id?: any, detail?: any) => Promise<any>;
  updateRegisterHostData: (data: any) => void;
  setUserData: (data: any) => void;
  updateHostList: (data?: any) => void;
  setSelectHostId: (data: any, callBack?: Function) => void;
} = {
  isMobile: undefined,
  isMeetingApp: false,
  hostDetail: defaultHostDetail,
  userData: defaultUserData,
  isHost: undefined,
  statusInfo: defaultStatus,
  isMobileUi: false,
  updateAppCtxHostDetail: defaultUpdateHostDetail,
  registerHostData,
  updateRegisterHostData,
  vipResourceDetail: defaultVipResourceDetail,
  setUserData: () => {},
  updateHostList: () => {},
  setSelectHostId: () => {},
};

export const AppContext = createContext(defaultValue);
// 权限管理
export enum ROLETYPE {
  CREATED = '1', // 创建者
  ADMIN = '2', // 管理员
  CUSTOM = '3', // 普通成员
}
